import { useSalaryInfo } from './useSalaryInfo';
import { useSalaryInfoEffects } from './useSalaryInfoEffects';

export { useSalaryInfoEffects, useSalaryInfo };
